import { AtlasV2OrganicTrafficPageLayout } from 'src/components/AtlasV2Components/AtlasV2PageLayouts/AtlasV2OrganicTrafficPageLayout';
import { AtlasV2PaidTrafficPageLayout } from 'src/components/AtlasV2Components/AtlasV2PageLayouts/AtlasV2PaidTrafficPageLayout';
import { AtlasV2TotalTrafficPageLayout } from 'src/components/AtlasV2Components/AtlasV2PageLayouts/AtlasV2TotalTrafficPageLayout';
import GenericPageContainer from 'src/components/EntityPage/GenericPageContainer';

export default function getAtlasV2TrafficLayout({ metricType }) {
  const trafficPageLayout = {
    totalClicks: AtlasV2TotalTrafficPageLayout,
    organicClicks: AtlasV2OrganicTrafficPageLayout,
    adClicks: AtlasV2PaidTrafficPageLayout
  };
  return {
    CustomPageContainer: GenericPageContainer,
    enableComparison: false,
    widgets: [
      {
        name: 'trafficPageLayout',
        CustomComponent: trafficPageLayout[metricType],
        view: {}
      }
    ],
    containerStyle: {},
    dataConfig: {}
  };
}
